// The checkout form has native required checks, but a guest row may be left blank (or is
// checked by Save attendee instead), so while guests show, only the other inputs are checked.
export default function reportValidityOutsideGuests(form) {
  if (!form) return true;
  const invalid = Array.from(form.elements).find(
    element =>
      !element.closest('[data-guest-rows]') && element.willValidate && !element.checkValidity(),
  );
  if (!invalid) return true;
  invalid.reportValidity();
  return false;
}
